import React from 'react';
import { Star, ShieldCheck } from 'lucide-react';
import { usePricingContext } from '../context/PricingContext';
export function HeroSection() {
  const {
    cartLink,
    fireAddToCart
  } = usePricingContext();
  return <section className="relative md:pt-24 md:pb-16 overflow-hidden pb-[10px] pt-[55px]" style={{
    background: 'linear-gradient(180deg, #F6F1E7 0%, #FBF8F2 50%, #F6F1E7 100%)'
  }} data-id="element-73">
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 80% 60% at 50% 40%, rgba(200,169,106,0.06) 0%, transparent 70%)'
    }} data-id="element-74" />
      <div className="absolute inset-0 opacity-[0.025] pointer-events-none" style={{
      backgroundImage: 'repeating-linear-gradient(0deg, rgba(180,140,60,1) 0, rgba(180,140,60,1) 1px, transparent 1px, transparent 60px), repeating-linear-gradient(90deg, rgba(180,140,60,1) 0, rgba(180,140,60,1) 1px, transparent 1px, transparent 60px)'
    }} data-id="element-75" />

      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-76">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-77">
          {/* Left: Product Image — desktop only */}
          <div className="order-2 md:order-1 relative hidden md:block" data-id="element-78">
            <div className="relative rounded-xl overflow-hidden" style={{
            boxShadow: '0 8px 40px rgba(60,40,10,0.15), 0 2px 8px rgba(60,40,10,0.08)',
            border: '1px solid rgba(200,169,106,0.3)'
          }} data-id="element-79">
              <img src="https://cdn.magicpatterns.com/uploads/jMadQsD1XevkwgmcqGLc4x/Capa-Cartas-de-Paulo.webp" alt="Las Cartas de Pablo — Explicadas Versículo por Versículo" className="w-full h-auto block" data-id="element-80" />
            </div>
            <div className="absolute -bottom-4 -right-4 flex flex-col items-center justify-center w-16 h-16 rounded-full" style={{
            background: 'linear-gradient(135deg, #B89555, #E6D3A3)',
            boxShadow: '0 4px 16px rgba(180,140,60,0.3)'
          }} data-id="element-81">
              <span className="text-sm font-black" style={{
              color: '#2A2115'
            }} data-id="element-82">
                100%
              </span>
              <span className="text-[8px] font-bold uppercase tracking-wide" style={{
              color: '#2A2115'
            }} data-id="element-83">
                Garantizado
              </span>
            </div>
          </div>

          {/* Right: Copy */}
          <div className="order-1 md:order-2" data-id="element-84">
            <div className="headline-glow mb-4" data-id="element-85">
              <h1 className="text-2xl md:text-[2.4rem] font-serif font-bold leading-tight" style={{
              color: '#161616'
            }} data-id="element-86">
                Domina Las{' '}
                <span className="text-gold-gradient" data-id="element-87">
                  13 Cartas del Apóstol Pablo
                </span>{' '}
                Explicadas Versículo por Versículo En Menos de 7 Días
              </h1>
            </div>

            <p className="text-base leading-relaxed mb-5" style={{
            color: '#2C2C2C'
          }} data-id="element-88">
              Entiende{' '}
              <strong style={{
              color: '#161616'
            }} data-id="element-89">
                TODA la teología paulina
              </strong>{' '}
              con explicaciones claras, contexto histórico y aplicación práctica
              — sin tecnicismos, sin seminario, sin confusión.
            </p>

            {/* Product Image — mobile only, above stars */}
            <div className="mb-4 rounded-xl overflow-hidden md:hidden" style={{
            boxShadow: '0 8px 40px rgba(60,40,10,0.12), 0 2px 8px rgba(60,40,10,0.06)',
            border: '1px solid rgba(200,169,106,0.25)'
          }} data-id="element-90">
              <img src="https://cdn.magicpatterns.com/uploads/jMadQsD1XevkwgmcqGLc4x/Capa-Cartas-de-Paulo.webp" alt="Las Cartas de Pablo — Explicadas Versículo por Versículo" className="w-full h-auto block" data-id="element-91" />
            </div>

            {/* Star Rating */}
            <div className="flex items-center mb-5 space-x-3" data-id="element-92">
              <div className="flex" data-id="element-93">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" style={{
                color: '#C8A96A'
              }} data-id="element-94" />)}
              </div>
              <span className="font-bold text-sm" style={{
              color: '#B89555'
            }} data-id="element-95">
                4.9/5
              </span>
              <span className="text-xs pl-3" style={{
              color: '#505050',
              borderLeft: '1px solid rgba(200,169,106,0.35)'
            }} data-id="element-96">
                Clientes Satisfechos
              </span>
            </div>

            <div className="flex flex-col space-y-3" data-id="element-97">
              <a href={cartLink} className="w-full" onClick={fireAddToCart} data-id="element-98">
                <button className="btn-sacred w-full text-lg py-4 font-serif tracking-wide" data-id="element-99">
                  QUIERO ACCESO INMEDIATO »
                </button>
              </a>
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-3 text-xs" style={{
              color: '#505050'
            }} data-id="element-100">
                <span className="flex items-center gap-1" data-id="element-101">
                  <ShieldCheck className="w-3 h-3" style={{
                  color: '#1A6B3A'
                }} data-id="element-102" />{' '}
                  Pago único
                </span>
                <span className="flex items-center gap-1" data-id="element-103">
                  <ShieldCheck className="w-3 h-3" style={{
                  color: '#1A6B3A'
                }} data-id="element-104" />{' '}
                  Sin suscripciones
                </span>
                <span className="flex items-center gap-1" data-id="element-105">
                  <ShieldCheck className="w-3 h-3" style={{
                  color: '#1A6B3A'
                }} data-id="element-106" />{' '}
                  Garantía total
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 gold-divider" data-id="element-107" />
    </section>;
}